"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (numUnit, chargePerUnit) => {
    const total = numUnit * chargePerUnit;
    const roundedTotal = Math.round((total + Number.EPSILON) * 100) / 100;
    return roundedTotal;
};
